import { React, useState } from "react";
import MyDatasets from "./components/MyDatasets";
import PublicDatasets from "./components/PublicDatasets";
import "./Data.css";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

const useStyles = makeStyles((theme) => ({
  tab: {
    margin: "20px 0px 5px 3%",
  },
}));

const tabStyles = makeStyles({
  root: {
    minHeight: "auto",
    minWidth: "auto",
    padding: 5,
    marginRight: 15,
    textTransform: "capitalize",
    fontSize: "1.1rem",
  },
});

const Data = (props) => {
  const [value, setValue] = useState(0);
  const tabClass = tabStyles();
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Tabs
        className={classes.tab}
        indicatorColor="secondary"
        value={value}
        onChange={handleChange}
        aria-label="simple tabs example"
      >
        <Tab className={tabClass.root} label="My Datasets" />
        <Tab className={tabClass.root} label="Public Datasets" />
      </Tabs>

      {value === 0 && (
        <MyDatasets
          onSelect={(db) => {
            props.onSelect(db);
          }}
        />
      )}

      {value === 1 && (
        <PublicDatasets
          onSelect={(db) => {
            props.onSelect(db);
          }}
        />
      )}
    </>
  );
};

export default Data;
